/* Bundle product popup — shared by Bundle Product Picker & CDC companion cards */
(function () {
  'use strict';

  function formatMoney(cents, moneyFormat) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
  }

  function initRoot(root) {
    if (!root || root.dataset.bpPopupInit === 'true') return;
    root.dataset.bpPopupInit = 'true';

    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var hideSizeGuide = root.dataset.hideSizeGuide === 'true';
    var popup = root.querySelector('[data-bp-popup]');
    if (!popup) return;

    var popupTitle = popup.querySelector('[data-bp-popup-title]');
    var popupPrice = popup.querySelector('[data-bp-popup-price]');
    var popupSubtitle = popup.querySelector('[data-bp-popup-subtitle]');
    var popupImages = popup.querySelector('[data-bp-popup-images]');
    var popupOptions = popup.querySelector('[data-bp-popup-options]');
    var qtyInput = popup.querySelector('[data-bp-qty-input]');
    var atcBtn = popup.querySelector('[data-bp-add-to-cart]');
    var urgencyEl = root.querySelector('[data-bp-urgency]');
    var urgencyText = root.querySelector('[data-bp-urgency-text]');
    var sizeGuideOverlay = root.querySelector('[data-bp-size-guide-overlay]');

    var currentProduct = null;
    var selectedOptions = {};
    var URGENCY_MIN = 3;
    var URGENCY_MAX = 9;

    function openSizeGuide() {
      if (!sizeGuideOverlay) return;
      sizeGuideOverlay.classList.add('bp-popup__size-guide-overlay--open');
      document.body.style.overflow = 'hidden';
    }

    if (sizeGuideOverlay) {
      var sgClose = sizeGuideOverlay.querySelector('[data-bp-size-guide-close]');
      if (sgClose) {
        sgClose.addEventListener('click', function () {
          sizeGuideOverlay.classList.remove('bp-popup__size-guide-overlay--open');
          if (!popup || popup.getAttribute('aria-hidden') !== 'false') {
            document.body.style.overflow = '';
          }
        });
      }
      sizeGuideOverlay.addEventListener('click', function (e) {
        if (e.target === sizeGuideOverlay) {
          sizeGuideOverlay.classList.remove('bp-popup__size-guide-overlay--open');
          if (!popup || popup.getAttribute('aria-hidden') !== 'false') {
            document.body.style.overflow = '';
          }
        }
      });
    }

    function getUrgencyCookie(productId, variantId) {
      var name = 'urgency_stock_' + productId + '_' + variantId;
      var match = document.cookie.match(new RegExp('(^| )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]+)'));
      return match ? parseInt(match[2], 10) : null;
    }

    function setUrgencyCookie(productId, variantId, count) {
      var name = 'urgency_stock_' + productId + '_' + variantId;
      document.cookie = name + '=' + count + '; max-age=3600; path=/; SameSite=Lax';
    }

    function updateUrgency(variant) {
      if (!urgencyEl || !urgencyText) return;
      if (!currentProduct || !variant || !variant.available) {
        urgencyEl.style.display = 'none';
        return;
      }
      var sizeIdx = 0;
      (currentProduct.options || []).forEach(function (opt, i) {
        if (/^size$/i.test(opt.name)) sizeIdx = i;
      });
      var sizeValue = (variant.options && variant.options[sizeIdx]) ? variant.options[sizeIdx] : '';
      var count = getUrgencyCookie(currentProduct.id, variant.id);
      if (count == null || count < URGENCY_MIN || count > URGENCY_MAX) {
        count = Math.floor(Math.random() * (URGENCY_MAX - URGENCY_MIN + 1)) + URGENCY_MIN;
        setUrgencyCookie(currentProduct.id, variant.id, count);
      }
      urgencyText.textContent = 'Only ' + count + ' left in size ' + sizeValue;
      urgencyEl.style.display = 'flex';
    }

    function renderColorImages(imgData) {
      var title = currentProduct ? currentProduct.title : '';
      var toShow = imgData.slice(-4);
      popupImages.innerHTML = '';
      for (var i = 0; i < 4; i++) {
        if (toShow[i]) {
          var el = document.createElement('img');
          el.alt = toShow[i].alt || title;
          el.classList.add('is-loading');
          el.addEventListener('load', function () { el.classList.remove('is-loading'); }, { once: true });
          if (el.complete) el.classList.remove('is-loading');
          el.src = toShow[i].src;
          popupImages.appendChild(el);
        } else {
          var placeholder = document.createElement('div');
          placeholder.style.cssText = 'width:100%;aspect-ratio:2/3;background:#f0ede8;';
          popupImages.appendChild(placeholder);
        }
      }
    }

    function findVariant() {
      if (!currentProduct) return null;
      return currentProduct.variants.find(function (v) {
        return currentProduct.options.every(function (opt, i) {
          return v.options[i] === selectedOptions[opt.name];
        });
      });
    }

    function updateAtcState() {
      if (!currentProduct) return;
      var allSelected = currentProduct.options.every(function (opt) { return selectedOptions[opt.name]; });
      if (allSelected) {
        var variant = findVariant();
        updateUrgency(variant);
        if (variant && variant.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = 'ADD TO BAG';
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = 'SOLD OUT';
        }
      } else {
        if (urgencyEl) urgencyEl.style.display = 'none';
        atcBtn.disabled = true;
        atcBtn.textContent = 'SELECT OPTIONS';
      }
    }

    function selectOption(name, value, group, isColor, optIndex) {
      selectedOptions[name] = value;
      group.querySelectorAll('button').forEach(function (b) {
        b.classList.remove('bp-popup__color-swatch--active');
        b.classList.remove('bp-popup__option-btn--active');
      });
      var cls = isColor ? 'bp-popup__color-swatch--active' : 'bp-popup__option-btn--active';
      var active = group.querySelector('[data-option-value="' + CSS.escape(value) + '"]');
      if (active) active.classList.add(cls);

      if (currentProduct) {
        var resolvedVariant = findVariant();
        var metaImgs = null;
        if (resolvedVariant && resolvedVariant.landing_page_images && resolvedVariant.landing_page_images.length) {
          metaImgs = resolvedVariant.landing_page_images;
        } else if (isColor) {
          var firstColorVariant = currentProduct.variants.find(function (v) {
            return v.options[optIndex] === value && v.landing_page_images && v.landing_page_images.length;
          });
          if (firstColorVariant) metaImgs = firstColorVariant.landing_page_images;
        }
        if (metaImgs) {
          renderColorImages(metaImgs);
        } else if (isColor) {
          var colorLower = value.trim().toLowerCase();
          var colorImgs = currentProduct.images.filter(function (img) {
            return img.alt && img.alt.trim().toLowerCase() === colorLower;
          });
          if (colorImgs.length === 0) {
            currentProduct.variants
              .filter(function (v) { return v.options[optIndex] === value && v.featured_image; })
              .forEach(function (v) {
                if (!colorImgs.find(function (i) { return i.src === v.featured_image.src; })) {
                  colorImgs.push({ src: v.featured_image.src, alt: currentProduct.title });
                }
              });
          }
          if (colorImgs.length === 0) colorImgs = currentProduct.images.slice();
          renderColorImages(colorImgs);
        } else if (resolvedVariant && resolvedVariant.landing_page_images && resolvedVariant.landing_page_images.length) {
          renderColorImages(resolvedVariant.landing_page_images);
        }
      }
      var variant = findVariant();
      if (variant) popupPrice.textContent = formatMoney(variant.price, moneyFormat);
      updateAtcState();
    }

    function openPopup(card) {
      var json = card.querySelector('.bundle-picker__product-json');
      if (!json) return;
      currentProduct = JSON.parse(json.textContent);
      selectedOptions = {};
      qtyInput.value = 1;
      popupTitle.textContent = currentProduct.title.toUpperCase();
      popupPrice.textContent = formatMoney(currentProduct.price, moneyFormat);
      popupSubtitle.textContent = currentProduct.description_short || '';
      popupImages.innerHTML = '';
      popupOptions.innerHTML = '';

      if (currentProduct.options && currentProduct.options.length) {
        var sortedOpts = currentProduct.options.map(function (opt, oi) { return { opt: opt, oi: oi }; });
        sortedOpts.sort(function (a, b) {
          var aRank = /^size$/i.test(a.opt.name) ? 0 : (/^colou?r$/i.test(a.opt.name) ? 1 : 2);
          var bRank = /^size$/i.test(b.opt.name) ? 0 : (/^colou?r$/i.test(b.opt.name) ? 1 : 2);
          return aRank - bRank;
        });

        sortedOpts.forEach(function (entry) {
          var opt = entry.opt;
          var oi = entry.oi;
          var isSize = /^size$/i.test(opt.name);
          var isColor = /^colou?r$/i.test(opt.name);
          var group = document.createElement('div');
          group.className = 'bp-popup__option-group';
          var labelRow = document.createElement('div');
          labelRow.className = 'bp-popup__option-label-row';
          var label = document.createElement('span');
          label.className = 'bp-popup__option-label';
          label.textContent = opt.name;
          labelRow.appendChild(label);
          if (isSize && !hideSizeGuide) {
            var sgBtn = document.createElement('button');
            sgBtn.type = 'button';
            sgBtn.className = 'bp-popup__size-guide-btn';
            sgBtn.textContent = 'Size guide';
            sgBtn.addEventListener('click', openSizeGuide);
            labelRow.appendChild(sgBtn);
          }
          group.appendChild(labelRow);
          var vals = document.createElement('div');
          vals.className = 'bp-popup__option-values';

          opt.values.forEach(function (val) {
            var valName = typeof val === 'object' ? (val.value || val.title || String(val)) : String(val);
            var btn = document.createElement('button');
            btn.type = 'button';
            if (isColor) {
              var valLower = valName.trim().toLowerCase();
              var swatchData = (currentProduct.color_swatches || []).find(function (s) {
                return s.name.trim().toLowerCase() === valLower;
              });
              var wrapper = document.createElement('div');
              wrapper.className = 'bp-popup__color-swatch-wrap';
              btn.className = 'bp-popup__color-swatch';
              btn.dataset.swatch = valLower;
              btn.title = valName;
              if (swatchData && swatchData.swatch_image) {
                btn.style.backgroundImage = 'url(' + swatchData.swatch_image + ')';
              } else if (swatchData && swatchData.color) {
                btn.style.backgroundColor = swatchData.color;
              }
              var colorLabel = document.createElement('span');
              colorLabel.className = 'bp-popup__color-label';
              colorLabel.textContent = valName;
              wrapper.appendChild(btn);
              wrapper.appendChild(colorLabel);
              vals.appendChild(wrapper);
            } else {
              btn.className = 'bp-popup__option-btn';
              btn.textContent = valName;
            }
            btn.dataset.optionName = opt.name;
            btn.dataset.optionValue = valName;
            btn.addEventListener('click', function () { selectOption(opt.name, valName, group, isColor, oi); });
            if (!isColor) vals.appendChild(btn);
          });
          group.appendChild(vals);
          popupOptions.appendChild(group);
          var firstBtn = vals.querySelector('button');
          if (firstBtn) firstBtn.click();
        });
      }
      updateAtcState();
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (urgencyEl) urgencyEl.style.display = 'none';
      if (sizeGuideOverlay) sizeGuideOverlay.classList.remove('bp-popup__size-guide-overlay--open');
      currentProduct = null;
    }

    root.querySelectorAll('.bundle-picker__product-json').forEach(function (el) {
      try {
        var data = JSON.parse(el.textContent);
        (data.images || []).forEach(function (img) {
          var preloader = new Image();
          preloader.src = img.src;
        });
      } catch (e) { /* ignore */ }
    });

    root.querySelectorAll('[data-bp-open-popup]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('[data-bp-product]');
        if (card) openPopup(card);
      });
    });

    popup.querySelectorAll('[data-bp-close-popup]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') closePopup();
    });

    var qtyMinus = popup.querySelector('[data-bp-qty-minus]');
    var qtyPlus = popup.querySelector('[data-bp-qty-plus]');
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = Math.min(10, (parseInt(qtyInput.value, 10) || 1) + 1);
      });
    }

    atcBtn.addEventListener('click', function () {
      var variant = findVariant();
      if (!variant) return;
      var qty = parseInt(qtyInput.value, 10) || 1;
      atcBtn.disabled = true;
      atcBtn.textContent = 'ADDING...';

      var sectionsToUpdate = ['page-header', 'cart-drawer']
        .map(function (sel) { return document.querySelector(sel); })
        .filter(function (el) { return el; });
      var sectionIds = sectionsToUpdate.map(function (el) { return el.dataset.sectionId; });
      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      fetch(cartUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variant.id, quantity: qty }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (resp) {
          if (!resp.ok) throw new Error('Add failed');
          return resp.json();
        })
        .then(function (data) {
          if (data.sections && sectionsToUpdate.length) {
            sectionsToUpdate.forEach(function (el) {
              var html = data.sections[el.dataset.sectionId];
              if (html && typeof el.updateFromCartChange === 'function') {
                el.updateFromCartChange(html);
              }
            });
          } else {
            document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
          }
          var cartDrawer = document.querySelector('.js-cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
          closePopup();
        })
        .catch(function () {
          atcBtn.textContent = 'ERROR — TRY AGAIN';
          setTimeout(updateAtcState, 2000);
        });
    });

    root._bpOpenPopup = openPopup;
  }

  function initAll() {
    document.querySelectorAll('[data-bp-popup-root]').forEach(initRoot);
  }

  window.BundleProductPopup = {
    init: initRoot,
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector ? evt.target.querySelector('[data-bp-popup-root]') : null;
    if (root) initRoot(root);
  });
})();
